import React, { useEffect } from 'react';
import Chart from 'react-apexcharts';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import { dominioDemandaCirurgica } from '../../../config/database';

export default function ProcedimentosIncluidosDemanda(props) {
  const [options, setOptions] = React.useState({
    series: [],
    labels: [],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
  });
  const [total, setTotal] = React.useState(Number(0));
  const { equipes, centrosCirurgicos, dataInicio, dataFim, eOnco } = props;

  const updateCharts = () => {
    const idsEquipes = equipes.map(equipe => {
      return equipe.id;
    });

    const idsCentrosCirurgicos = centrosCirurgicos.map(centroCirurgico => {
      return centroCirurgico.id;
    });

    const dados = {
      filtros: {
        equipes: idsEquipes?.length > 0 ? idsEquipes.join() : null,
        centrosCirurgicos: idsCentrosCirurgicos?.length > 0 ? idsCentrosCirurgicos.join() : null,
        dataInicio: new Date(dataInicio),
        dataFim: new Date(dataFim),
        eOnco,
      },
    };

    dominioDemandaCirurgica
      .post(`/api/listarProcedimentosIncluidosDemanda`, dados)
      .then(response => {
        const config = {
          series: [],
          labels: [],
          dataLabels: {
            enabled: false,
          },
          legend: {},
          title: {
            text: '',
            offsetX: 0,
            align: 'center',
            style: {
              fontSize: '20px',
            },
          },
        };
        const series = response.data.map(dado => {
          return dado.quantidadedemandas;
        });
        const labels = response.data.map(dado => {
          return dado.Demanda_procedimentoPrincipal;
        });
        const sum = response.data
          .map(dado => {
            return dado.quantidadedemandas;
          })
          .reduce((partialSum, a) => partialSum + a, 0);
        setTotal(sum);
        config.series = series;
        config.labels = labels;
        config.title.text = `Total: ${sum}`;
        setOptions(config);
      });
  };

  useEffect(() => {
    updateCharts();
  }, [equipes, centrosCirurgicos, dataInicio, dataFim, eOnco]);

  return (
    <Card style={{ height: 235, width: '100%' }}>
      <CardHeader
        align="center"
        title="Quantidade de procedimentos principais inclusos na demanda"
        disableTypography
        style={{
          backgroundColor: '#32428C',
          color: 'white',
          height: 60,
          fontSize: 18,
          fontWeight: 'bold',
        }}
      />
      <CardContent>
        <Chart options={options} series={options.series} type="pie" height={164} />
      </CardContent>
    </Card>
  );
}
